import { Injectable, EventEmitter } from '@angular/core';

/**
 * Author: Redza Rosli
 * 
 * Date Created: August 16th 2018
 * 
 * Description: Service class for Online Statistic
 **/
@Injectable()
export class StatisticService {
  allUser: any;
  newUser: any;
  statAllUpdated = new EventEmitter();

  constructor() { }
  getAllUserData() {
      return this.allUser;
  }
  getNewUserData() {
      return this.newUser;
  }

}



// WEBPACK FOOTER //
// ./src/app/statistic/statistic.service.ts